module.exports = __webpack_public_path__ + "img/currentLocation.b98b6069.svg";